function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 480 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,91.3,247.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7508,0,0,1.7508,-146.922,-56.7713)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M289.9,10.8C289.9,9 291.4,7.5 293.2,7.5C295,7.5 296.5,9 296.5,10.8C296.5,12.6 295,14.1 293.2,14.1C291.3,14 289.9,12.6 289.9,10.8ZM296.1,10.7C296.1,9.1 294.8,7.7 293.2,7.7C291.5,7.7 290.2,9 290.2,10.7C290.2,12.3 291.5,13.6 293.1,13.6C294.8,13.7 296.1,12.4 296.1,10.7ZM291.7,8.9L293.3,8.9C293.8,8.9 294.1,9 294.3,9.3C294.5,9.5 294.6,9.7 294.6,10C294.6,10.6 294.3,10.9 293.8,11L294.7,12.3L293.9,12.3L293.1,11.1L292.4,11.1L292.4,12.3L291.7,12.3L291.7,8.9ZM293.4,10.6C293.8,10.6 294.1,10.4 294.1,10.1C294.1,9.8 293.8,9.6 293.4,9.6L292.5,9.6L292.5,10.7L293.4,10.7L293.4,10.6Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.25px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.2,17.7L41.8,17C43.1,18.2 44.3,18.8 46.1,18.8C47.9,18.8 49.1,17.8 49.1,16.4C49.1,15.1 48.4,14.4 45.7,13.9C42.8,13.3 41.7,12.4 41.7,10.6C41.7,8.8 43.3,7.5 45.5,7.5C47.2,7.5 48.4,8 49.6,8.9L49,9.6C47.9,8.6 46.8,8.3 45.4,8.3C43.6,8.3 42.5,9.3 42.5,10.5C42.5,11.8 43.1,12.5 46,13.1C48.8,13.7 49.9,14.6 49.9,16.4C49.9,18.3 48.3,19.6 46,19.6C44.1,19.6 42.7,18.9 41.2,17.7Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.8,
    y: 7.5,
    width: 0.9,
    height: 11.9,
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2,7.5L58,7.5L62.8,14.5L67.6,7.5L68.4,7.5L68.4,19.4L67.5,19.4L67.5,9.1L62.8,15.9L62.7,15.9L58,9.1L58,19.4L57.2,19.4L57.2,7.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,7.5L76.1,7.5C78.7,7.5 80.5,8.8 80.5,11.1C80.5,13.6 78.3,14.9 75.9,14.9L72.7,14.9L72.7,19.3L71.8,19.3L71.8,7.5ZM75.9,14.1C78.1,14.1 79.6,12.9 79.6,11.2C79.6,9.3 78.1,8.3 76,8.3L72.6,8.3L72.6,14.1L75.9,14.1Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2,17.7L82.8,17C84.1,18.2 85.3,18.8 87.1,18.8C88.9,18.8 90.1,17.8 90.1,16.4C90.1,15.1 89.4,14.4 86.7,13.9C83.8,13.3 82.7,12.4 82.7,10.6C82.7,8.8 84.3,7.5 86.5,7.5C88.2,7.5 89.4,8 90.6,8.9L90,9.5C88.9,8.5 87.8,8.2 86.4,8.2C84.6,8.2 83.5,9.2 83.5,10.4C83.5,11.7 84.1,12.4 87,13C89.8,13.6 90.9,14.5 90.9,16.3C90.9,18.2 89.3,19.5 87,19.5C85.1,19.6 83.6,18.9 82.2,17.7Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1,13.5C93.1,10.2 95.5,7.3 99.1,7.3C102.7,7.3 105.1,10.2 105.1,13.4C105.1,16.6 102.7,19.6 99.1,19.6C95.5,19.6 93.1,16.7 93.1,13.5ZM104.2,13.5C104.2,10.5 102.1,8.1 99.1,8.1C96.2,8.1 94.1,10.5 94.1,13.4C94.1,16.3 96.2,18.8 99.2,18.8C102.1,18.8 104.2,16.4 104.2,13.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8,7.5L108.7,7.5L116.9,17.8L116.9,7.5L117.7,7.5L117.7,19.4L117,19.4L108.6,8.8L108.6,19.4L107.8,19.4L107.8,7.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.2,17.7L137.8,17C139.1,18.2 140.3,18.8 142.1,18.8C143.9,18.8 145.1,17.8 145.1,16.4C145.1,15.1 144.4,14.4 141.7,13.9C138.8,13.3 137.7,12.4 137.7,10.6C137.7,8.8 139.3,7.5 141.5,7.5C143.2,7.5 144.4,8 145.6,8.9L145,9.5C143.9,8.5 142.8,8.2 141.4,8.2C139.6,8.2 138.5,9.2 138.5,10.4C138.5,11.7 139.1,12.4 142,13C144.8,13.6 145.9,14.5 145.9,16.3C145.9,18.2 144.3,19.5 142,19.5C140.1,19.6 138.7,18.9 137.2,17.7Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.7,7.5L153,7.5C155.6,7.5 157.4,8.8 157.4,11.1C157.4,13.6 155.2,14.9 152.8,14.9L149.6,14.9L149.6,19.3L148.7,19.3L148.7,7.5ZM152.8,14.1C155,14.1 156.5,12.9 156.5,11.2C156.5,9.3 155,8.3 152.9,8.3L149.5,8.3L149.5,14.1L152.8,14.1Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,7.5L168.4,7.5L168.4,8.3L160.8,8.3L160.8,13L167.6,13L167.6,13.8L160.8,13.8L160.8,18.6L168.5,18.6L168.5,19.4L160,19.4L160,7.5L159.9,7.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,7.5L171.9,7.5L180.1,17.8L180.1,7.5L180.9,7.5L180.9,19.4L180.2,19.4L171.8,8.8L171.8,19.4L171,19.4L171,7.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.8,13.5C183.8,10.1 186.3,7.3 189.7,7.3C191.8,7.3 193.1,8.1 194.3,9.2L193.7,9.8C192.7,8.8 191.5,8 189.7,8C186.8,8 184.7,10.3 184.7,13.3C184.7,16.3 186.9,18.7 189.7,18.7C191.4,18.7 192.6,18 193.8,16.8L194.4,17.4C193.1,18.6 191.8,19.5 189.7,19.5C186.3,19.6 183.8,16.9 183.8,13.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.7,7.5L205.2,7.5L205.2,8.3L197.6,8.3L197.6,13L204.4,13L204.4,13.8L197.6,13.8L197.6,18.6L205.3,18.6L205.3,19.4L196.8,19.4L196.8,7.5L196.7,7.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6,14.7L223.5,7.5L224.6,7.5L229.1,13.9L233.6,7.5L234.7,7.5L229.6,14.7L229.6,19.4L228.7,19.4L228.7,14.7L228.6,14.7Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.2,13.5C235.2,10.2 237.6,7.3 241.2,7.3C244.8,7.3 247.2,10.2 247.2,13.4C247.2,16.6 244.8,19.6 241.2,19.6C237.5,19.6 235.2,16.7 235.2,13.5ZM246.2,13.5C246.2,10.5 244.1,8.1 241.1,8.1C238.2,8.1 236.1,10.5 236.1,13.4C236.1,16.3 238.2,18.8 241.2,18.8C244.1,18.8 246.2,16.4 246.2,13.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8,14.4L249.8,7.4L250.7,7.4L250.7,14.3C250.7,17.1 252.2,18.7 254.7,18.7C257.1,18.7 258.7,17.2 258.7,14.4L258.7,7.4L259.6,7.4L259.6,14.2C259.6,17.6 257.6,19.4 254.7,19.4C251.8,19.6 249.8,17.8 249.8,14.4Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7,7.5L263.5,7.5L271.7,17.8L271.7,7.5L272.5,7.5L272.5,19.4L272,19.4L263.6,8.8L263.6,19.4L262.8,19.4L262.8,7.5L262.7,7.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.5,13.5C275.5,10.3 277.8,7.3 281.4,7.3C283.3,7.3 284.6,7.9 285.8,8.9L285.2,9.6C284.3,8.8 283.2,8.2 281.4,8.2C278.5,8.2 276.5,10.6 276.5,13.5C276.5,16.6 278.4,18.9 281.6,18.9C283.1,18.9 284.5,18.3 285.4,17.5L285.4,14L281.4,14L281.4,13.2L286.2,13.2L286.2,17.8C285.1,18.8 283.5,19.6 281.5,19.6C277.7,19.6 275.5,16.8 275.5,13.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128.1,
    y: 7.8,
    width: 0.7,
    height: 12,
    style: {
      fill: "rgb(161,135,90)",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 7.8,
    width: 0.7,
    height: 12,
    style: {
      fill: "rgb(161,135,90)",
      stroke: "rgb(161,135,90)",
      strokeWidth: "0.5px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.80058,0,0,6.80058,33.7702,-239.696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3,3.6C20.3,3.6 15,0.4 11.1,3.3C11.1,3.3 14.1,3.1 17.2,5.3L20.3,3.6Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3,8.1C32.3,8.1 32.1,7.7 31.9,7.5C31.9,7.5 29.8,9.7 25.5,7.6L22.5,9.5C22.5,9.5 26,11.2 29,10.5C31.7,9.7 32.3,8.1 32.3,8.1Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3,17.2C32.3,17.2 32.1,16.8 31.9,16.6C31.9,16.6 29.8,18.8 25.5,16.7L22.5,18.6C22.5,18.6 26,20.3 29,19.6C31.7,18.8 32.3,17.2 32.3,17.2Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,10.5C1,10.5 0,14.7 5.4,15.8C10.1,16.7 17.7,11.5 20.9,9.5C24.1,7.5 30.1,3.2 32.8,7.7C32.8,7.7 33.1,6.2 32.3,4.8C31.5,3.5 29.6,2.2 26.2,2.5C23.9,2.7 20.5,3.9 13.6,8.4C6.7,12.9 3.4,14 1,10.5Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,23.7C13.6,23.7 18.9,26.9 22.8,24C22.8,24 19.8,24.2 16.7,22L13.6,23.7Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,19.2C1.5,19.2 1.7,19.6 1.9,19.8C1.9,19.8 4,17.6 8.3,19.7L11.3,17.8C11.3,17.8 7.8,16.1 4.8,16.8C2.1,17.6 1.5,19.2 1.5,19.2Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,10.1C1.5,10.1 1.7,10.5 1.9,10.7C1.9,10.7 4,8.5 8.3,10.6L11.3,8.7C11.3,8.7 7.8,7 4.8,7.7C2.1,8.5 1.5,10.1 1.5,10.1Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8,16.8C32.8,16.8 33.8,12.6 28.4,11.5C23.7,10.6 16.1,15.8 12.9,17.8C9.7,19.8 3.7,24.2 1,19.6C1,19.6 0.7,21.1 1.5,22.5C2.3,23.8 4.2,25.1 7.6,24.8C9.9,24.6 13.3,23.4 20.2,18.9C27.1,14.4 30.4,13.2 32.8,16.8Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,14.2C14.2,14.2 16.1,13.2 17.7,12.1L19.5,13.1C19.3,13.3 17.4,14.3 15.9,15.2L14.2,14.2Z",
    style: {
      fill: "rgb(161,135,90)",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.01558b00f20caa50707cee6c3bf2f604.svg";
export { ForwardRef as ReactComponent };